export const LOAD_TASKS = 'LOAD_TASKS';
export const SELECT_TASK = 'SELECT_TASK';
export const SOLVE_TASK = 'SOLVE_TASK';
export const REDUCE_EARNED_POINTS = 'REDUCE_EARNED_POINTS';
